<div class="container-text">
    <div class="no-data-container">
        <div class="message">
            <p>{{ "m019" | lang }}</p>
        </div>
    </div>
</div>
